import {useSelector} from 'react-redux';

import fwuService from '@/services/fwu/fwuService';
import {selectIsFwuCheckEnabled} from '@/state/selectors/consumerAggregatedSettings';
import {selectDeviceType} from '@/state/selectors/device';

const useFwuBackgroundCheckEnabled = () => {
    const isFwuCheckEnabled = useSelector(selectIsFwuCheckEnabled);
    const deviceType = useSelector(selectDeviceType);
    const isFwuAvailable = fwuService.isFwuAvailable(deviceType);

    return isFwuAvailable && isFwuCheckEnabled;
};

export default useFwuBackgroundCheckEnabled;
